import React, { useEffect, useState, useRef } from 'react'
import { Blurhash } from "react-blurhash";

function IFrameLazy({horizontal, src, hash}) {
    const aspect = horizontal ? 9/16 : 16/9;
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [width, setWidth] = useState(false);
    const frameRef = useRef();

    useEffect(() => {
        const onResize = () => {
            let padding = Math.min(40, 0.08*window.innerWidth);
            let mainwidth = window.innerWidth - 2*padding;
            if(window.innerWidth < 600){
                setWidth(mainwidth - 15);
            }else if(window.innerWidth < 800){
                setWidth((mainwidth - 30)/2);
            }else if(window.innerWidth < 1000){
                setWidth((mainwidth - 30)/3);
            }else{
                setWidth((mainwidth - 30)/4);
            }
        }

        const setLoaded = () => {
            setIframeLoaded(true);
            console.log("Hi");
        }

        window.addEventListener("resize", onResize);
        onResize();
        
        let frame;
        if (frameRef && frameRef.current) {
            frame = frameRef.current;
            frame.addEventListener("load", setLoaded, false);
        }
    
        return () => {
            window.removeEventListener("resize", onResize);
            if(frame) frame.removeEventListener("load", setLoaded, false);
        }
    }, [frameRef]);

  return (
    <div className='IframeLazy'>
        {
            !iframeLoaded ?
                <Blurhash
                    hash={hash}
                    width={width}
                    height={aspect*width}
                    resolutionX={32}
                    resolutionY={32}
                    punch={1}
            /> : ""
        }
        <iframe style={{display: iframeLoaded ? "block" : "none"}} ref={frameRef} className={`gallery ${horizontal ? "horizontal": "vertical"}`} src={src} frameborder="0" title="Plaza" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </div>
  )
}

export default IFrameLazy